import React from 'react';
import { BsExclamationCircleFill, BsFillArrowUpSquareFill, BsFillXCircleFill, BsFolderSymlinkFill, BsPencilSquare, BsUpload } from 'react-icons/bs';
import ContentDiv from './ContentDiv';
import { Server } from 'src/server/server';
import { NavLink } from 'react-router-dom';
import { AiOutlineRetweet } from 'react-icons/ai';
import './ContentPanel.css';
import Portrait from './Portrait';
import { BiExport, BiWindowOpen } from 'react-icons/bi';


interface ContentPanelProps {
  author: string;
  date: string;
  title?: string;
  content: string;
  reply?: boolean;
  action?: string;
  onAction?: Function;
  children?: any;
  onClick?: Function;
  repost?: string;
  summary?: boolean;
  read?: boolean;
  onShare?: Function;
  onConvert?: Function;
}

interface ContentPanelState {
}

class ContentPanel extends React.Component<ContentPanelProps, ContentPanelState> {
  
  constructor(props: ContentPanelProps) {
    super(props);

    this.state = {
    };
  }
  
  formatDate(date:Date) {
    let now = new Date();
    let elapsed = now.getTime() - date.getTime();
    let hours = Math.floor(elapsed / 1000 / 60 / 60);
    let mins = Math.floor(elapsed / 1000 / 60);
    let secs = Math.floor(elapsed / 1000);
    

    let dateStr = '';
    if(hours >= 24) 
      dateStr = date.toLocaleString(undefined, {month: "short", day: "numeric", hour: "numeric", minute: "numeric"})
    else if(hours > 0 && hours < 24)
      dateStr = hours + 'h ago';
    else if(hours == 0 && mins > 0)
      dateStr = mins + 'm ago';
    else if(hours == 0 && mins == 0 && secs > 0)
      dateStr = secs + 's ago';
    else if(hours == 0 && mins == 0 && secs == 0)
      dateStr = 'Just Now';

    return dateStr;
  }

  isMobile() {
    return window.matchMedia('(max-width: 500px)').matches;
  }
  
  onAction(e:any) {
    e.stopPropagation();
    this.props.onAction();
  }

  onClick() {
    if(this.props.onClick)
      this.props.onClick();
  }

  onShare(e:any) {
    e.stopPropagation();
    this.props.onShare();
  }

  onConvert(e:any) {
    e.stopPropagation();
    this.props.onConvert();
  }

  render() {
    let author = Server.public.getProfile(this.props.author);
    
    if(!author) {
      console.error('Post author not found!', this.props.author);
      return null;
    }

    let margin = this.props.reply && !this.isMobile() ? 55 : 0;
    let d = new Date(this.props.date);
    let date = this.props.reply ? this.formatDate(d) : d.toLocaleString(undefined, {month: "short", day: "numeric", hour: "numeric", minute: "numeric"});
    let slug ='@' + author.slug;
    let actionButton = null;
    
    if(this.props.action == 'delete')
      actionButton = <BsFillXCircleFill size="1.2em" />;
    else if(this.props.action == 'edit')
      actionButton = <BsPencilSquare size="1.2em" />;

    let cursor = this.props.onClick ? 'pointer' : 'unset';

    let repostAuthor = null;
    if(this.props.repost) 
      repostAuthor = Server.public.getProfile(this.props.repost);

    return (
      <div className="site-page-panel" style={{position: 'relative', rowGap: '0px', cursor, paddingRight: '15px'}} onClick={()=>this.onClick()}>

        {this.props.repost && 
          <NavLink to={'/profile/' + repostAuthor.slug} style={{textDecoration: 'none'}}>
            <div className="site-page-row" style={{alignItems: 'center', marginLeft: '25px', marginBottom: '-5px', color: 'var(--panel-subtext-color)'}}>
              <AiOutlineRetweet style={{fontSize: '1.1em'}} />
              <div style={{fontSize: '0.9em'}}>
                {repostAuthor.name} reposted
              </div>
            </div>
          </NavLink>
        }

        <div className="site-page-row">
          <NavLink to={'/profile/' + author.slug} onClick={(e)=>e.stopPropagation()}>
            <Portrait user={author.id} />
          </NavLink>
          <div>
            <div className="site-page-row">
              <NavLink to={'/profile/' + author.slug} style={{textDecoration: 'none'}} onClick={(e)=>e.stopPropagation()}>
                <b>{author.name}</b>
              </NavLink>
              <NavLink to={'/profile/' + author.slug} className="site-page-small-subtext" style={{marginBottom: '1px', textDecoration: 'none'}} onClick={(e)=>e.stopPropagation()}>
                {this.props.reply && slug}
              </NavLink>    
            </div>
            <NavLink to={'/profile/' + author.slug} className="site-page-small-subtext" style={{marginTop: '2px', textDecoration: 'none'}}>
              {this.props.reply ? date : slug}
            </NavLink>
          </div>
        </div>

        {this.props.title && 
          <div style={{fontSize: '1.1em', marginTop: '10px'}}><b>{this.props.title}</b></div>
        }

        <div style={{height: '5px'}} />

        <div style={{marginLeft: margin + 'px'}}>
          <ContentDiv content={this.props.content} summary={this.props.summary} />
        </div>

        {!this.props.reply && 
          <div className="site-page-subtext" style={{marginTop: '5px'}}>{date}</div>
        }

        {this.props.children}

        {this.props.onShare &&
        <div 
            id="ShareButton"
            style={{position: 'absolute', top: '8px', right: this.props.action != '' ? '38px' : '8px', cursor: 'pointer', color: 'var(--panel-subtext-color)'}} 
            onClick={(e:any)=>this.onShare(e)}
            title="Share to activity feed"
            >
              <BiExport size="1.4em" style={{marginTop: '-3px'}} />
          </div>
        }

        {this.props.onConvert && author.id == Server.user.getId() &&
          <div 
            id="ConvertButton"
            style={{position: 'absolute', top: '8px', right: this.props.action != '' ? '38px' : '8px', cursor: 'pointer', color: 'var(--panel-subtext-color)'}} 
            onClick={(e:any)=>this.onConvert(e)}
            title="Convert to forum post"
            >
              <BsFolderSymlinkFill size="1.4em" style={{marginTop: '-1px'}} />
          </div>
        }

        {this.props.action != '' &&
          <div 
            id="ActionButton"
            style={{position: 'absolute', top: '8px', right: '8px', cursor: 'pointer', color: 'var(--panel-subtext-color)'}} 
            onClick={(e:any)=>this.onAction(e)}
          >
            {actionButton}
          </div>
        }

        {this.props.read != undefined && !this.props.read &&
          <div className="site-page-notify-circle" style={{position: 'absolute', right: '5px', top: '5px'}}>
            <BsExclamationCircleFill size="1.2em" />
          </div>
        }

      </div>
    )
  }
}

export default ContentPanel;